import(/* webpackMode: "eager", webpackExports: ["default"] */ "G:\\Nexo3d.ir\\node_modules\\lucide-react\\dist\\esm\\Icon.mjs");
;
import(/* webpackMode: "eager" */ "G:\\Nexo3d.ir\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "G:\\Nexo3d.ir\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "G:\\Nexo3d.ir\\node_modules\\next\\font\\local\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../node_modules/@fontsource-variable/vazirmatn/files/vazirmatn-arabic-wght-normal.woff2\",\"weight\":\"100 900\",\"style\":\"normal\",\"display\":\"optional\",\"preload\":true,\"adjustFontFallback\":\"Arial\",\"fallback\":[\"Tahoma\",\"Arial\",\"sans-serif\"],\"variable\":\"--font-vazirmatn\"}],\"variableName\":\"vazirmatn\"}");
;
import(/* webpackMode: "eager" */ "G:\\Nexo3d.ir\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTop"] */ "G:\\Nexo3d.ir\\src\\components\\back-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "G:\\Nexo3d.ir\\src\\components\\cart-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredTrustBadge"] */ "G:\\Nexo3d.ir\\src\\components\\deferred-trust-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "G:\\Nexo3d.ir\\src\\components\\header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileBottomNav"] */ "G:\\Nexo3d.ir\\src\\components\\mobile-bottom-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteToast"] */ "G:\\Nexo3d.ir\\src\\components\\site-toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportLauncherLoader"] */ "G:\\Nexo3d.ir\\src\\components\\support-launcher-loader.tsx");
